import React from "react";
import {useDispatch, useSelector} from "react-redux";
import Pagination from "../components/pagination";
import DocumentsTable from "../components/documents/DocumentsTable";
import DocumentFormModal from "../components/documents/DocumentFormModal";
import {Button} from "react-bootstrap";

const DocumentsTab = ({}) => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });
  const dispatch = useDispatch();

  const [documents, setDocuments] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);

  const fetchDocuments = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/documents.json`,
      data: {
        page: currentPage
      },
      success: (response) => {
        setDocuments(response.documents);
        setTotalPages(response.total_pages);
      }
    })
  }

  React.useEffect(() => {
    fetchDocuments();
  }, [currentPage]);

  const openModal = () => {
    dispatch({type: "OPEN_RESOURCE_MODAL", payload: {resourceName: 'document'}});
  }

  return <>
    <div className="d-flex justify-content-center mt-4">
      <Pagination
        total_pages={totalPages}
        currentPage={currentPage}
        onPageChange={(page) =>
          setCurrentPage(page.selected + 1)
        }/>
    </div>
    <DocumentFormModal setDocuments={setDocuments}/>
    <DocumentsTable documents={documents}/>
    <div className="d-flex justify-content-center">
      <Button
        variant="link"
        onClick={() => openModal()}
      >
        Add Document
      </Button>
    </div>
  </>;
}

export default DocumentsTab;
